import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router';
Vue.use(VueRouter)

import index from './index.vue'

import converters from '@converters/admin/layout.vue'

import converters_router from '@converters/admin/routes.js'

const router = [
    {
        path: '', component: index, name: 'admin_index',
    },
    {
        path: 'converters', component: converters,
        children: converters_router
    },
]

export default router;
